export const MEMBERSHIP_STATUS = {
  Pending: 'pending',
  Completed: 'completed',
} as const
export type MembershipStatus = (typeof MEMBERSHIP_STATUS)[keyof typeof MEMBERSHIP_STATUS]
